class AlAnfarScentAtlas extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-atlas-rail]');
    this.viewport = this.querySelector('.aa-atlas__viewport');
    this.previous = this.querySelector('[data-atlas-previous]');
    this.next = this.querySelector('[data-atlas-next]');
    if (!this.rail || !this.previous || !this.next) return;

    this.handleScroll = () => this.updateControls();
    this.previous.addEventListener('click', () => this.scroll(-1));
    this.next.addEventListener('click', () => this.scroll(1));
    this.rail.addEventListener('scroll', this.handleScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(this.handleScroll);
    this.resizeObserver.observe(this.rail);
    requestAnimationFrame(this.handleScroll);
  }

  disconnectedCallback() {
    this.rail?.removeEventListener('scroll', this.handleScroll);
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.travelFrame);
  }

  scroll(direction) {
    const item = this.rail.querySelector('.aa-atlas__note');
    const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
    const distance = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth * 0.75;
    const maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const target = Math.min(maximum, Math.max(0, this.rail.scrollLeft + direction * distance));

    this.travelTo(target);
  }

  travelTo(target) {
    cancelAnimationFrame(this.travelFrame);
    const start = this.rail.scrollLeft;
    const distance = target - start;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(distance) < 2) {
      this.rail.scrollLeft = target;
      return;
    }

    const startedAt = performance.now();
    const duration = 300;
    const tick = (time) => {
      const progress = Math.min(1, (time - startedAt) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.rail.scrollLeft = start + (distance * eased);
      if (progress < 1) this.travelFrame = requestAnimationFrame(tick);
    };
    this.travelFrame = requestAnimationFrame(tick);
  }

  updateControls() {
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    const scrollable = max > 2;
    const atStart = !scrollable || this.rail.scrollLeft <= 2;
    const atEnd = !scrollable || this.rail.scrollLeft >= max - 2;
    this.previous.disabled = atStart;
    this.next.disabled = atEnd;
    this.viewport?.classList.toggle('is-scrollable', scrollable);
    this.viewport?.classList.toggle('is-at-start', atStart);
    this.viewport?.classList.toggle('is-at-end', atEnd);
  }
}

if (!customElements.get('al-anfar-scent-atlas')) {
  customElements.define('al-anfar-scent-atlas', AlAnfarScentAtlas);
}
